import {PADDING_DIRECTION_CLASSES, PADDING_INDENT_CLASSES} from './constants';

import type {PaddingDirectionType, PaddingIndentType} from './constants';
import type {PaddingType} from './typedef';

/**
 * Generate a padding classes
 * @param element - Class name
 * @param padding - Padding config
 * @returns {string}
 */
export const generatePaddingClasses = (element: string, padding: PaddingType): string => (
    Object
        .keys(padding)
        .filter(item => padding[item as keyof PaddingType])
        .map(item => {
            const direction = item as PaddingDirectionType;
            const indent = padding[direction] as PaddingIndentType;

            return `${element}_${PADDING_DIRECTION_CLASSES[direction]}-${PADDING_INDENT_CLASSES[indent]}`;
        })
        .join(' ')
);
